// extracted by mini-css-extract-plugin
export default {"head":"PanelItem_head__zVg+2","icon":"PanelItem_icon__l6lVb","avatar":"PanelItem_avatar__CTtQd","title":"PanelItem_title__IOudF","description":"PanelItem_description__h0qVV"};